import type { RootState } from 'state';
import type { AirportGroupingsState } from '../slice';

function getDepartureAirportGroupings(state: RootState): AirportGroupingsState['departureGroupings'] {
  const { departureGroupings } = state.dataService.airports.airportGroupings;
  return departureGroupings;
}

export default getDepartureAirportGroupings;
